export default __webpack_public_path__ + "static/media/330_dummy2016-sportbekleidung01-de.aa8f465f.png";